import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, switchMap } from 'rxjs';
import { getBrand } from '../../utils/getBrand';
import { RealmName } from '../types/enum';
import { v4 as uuidv4 } from 'uuid';
import { getMservicesEnvPrefix } from '../../utils/getMservicesEnvPrefix';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  constructor(private http: HttpClient) {}

  getUserAccount(accountNumber: string, lang: string): Observable<any> {
    const brand: string = getBrand().name;
    return this.getAccountList(lang, brand).pipe(
      switchMap((accountList) => {
        const accountDetail = accountList.content?.accounts?.find(
          (account: any) => account.accountNumber === accountNumber
        );
        if (accountDetail?.alias) {
          return this.getContactDetails(accountDetail.alias, lang, brand);
        } else {
          throw new Error('No Account Found');
        }
      })
    );
  }

  private getAccountList(lang: string, brand: string): Observable<any> {
    const xAppName = brand == RealmName.fido ? 'VA-FIDO' : 'VA-ROGERS';
    let url = `https://${getMservicesEnvPrefix()}mservices.rogers.com/ssc/accounts/v2/customer/accounts/list?${Date.now()}`;
    if (brand == RealmName.fido && window.location.href.includes('fido')) {
      url = url.replace('rogers.com', 'fido.ca');
    }
    return this.http.get(url, {
      headers: {
        'X-App-Id': 'Rogers.com',
        'X-App-Name': xAppName,
        realm: brand.toUpperCase(),
        Language: lang,
        'X-Transaction-Id': uuidv4(),
      },
      withCredentials: true,
    });
  }

  private getContactDetails(
    alias: string,
    lang: string,
    brand: string
  ): Observable<any> {
    const xAppName = brand == RealmName.fido ? 'VA-FIDO' : 'VA-ROGERS';
    let url = `https://${getMservicesEnvPrefix()}mservices.rogers.com/v2/customer/account/${alias}/contactdetails`;
    if (brand == RealmName.fido && window.location.href.includes('fido')) {
      url = url.replace('rogers.com', 'fido.ca');
    }
    return this.http.get(url, {
      headers: {
        'X-App-Id': 'Rogers.com',
        'X-App-Name': xAppName,
        realm: brand.toUpperCase(),
        Language: lang,
        'X-Transaction-Id': uuidv4(),
      },
      withCredentials: true,
    });
  }

  loadBannedWords(lang: string): Observable<string[]> {
    return this.http
      .get(`configurations/banned-words/banned-${lang}.json`)
      .pipe(map((item: any) => item.words));
  }
}
